module.exports = __webpack_public_path__ + "static/media/inventory.19c14841.svg";